import script from "./TechnologyAssetsComparisonTableHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechnologyAssetsComparisonTableHeader.vue?vue&type=script&setup=true&lang=ts"

import "./TechnologyAssetsComparisonTableHeader.vue?vue&type=style&index=0&id=13afef98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13afef98"]])

export default __exports__